import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { sentryDSN } from './constants/constants.json';

import Themes from './layouts';
import App from './components/App';

import './style.css';

import store from './redux/store';
import Notifications from './pages/notifications/Notifications';

Sentry.init({
    dsn: sentryDSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV === 'development' ? 'development' : 'production'
});

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={Themes.default}>
            <CssBaseline />
            <App />
            <Notifications />
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
);
